// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WN3D","largestCol":"styles_largestCol__16DoI","smallestCol":"styles_smallestCol__3vZ4X"};